import React, { memo, useCallback, useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import FileComment from '../../FileExplorer/FileComment';
import * as DriveHelper from '../../../helpers/Drive';
import './FileCommentsModal.scss';
import {
    getFileInformation,
    postFileComment,
} from '../../../api/actions/Documents';
import { toast } from 'react-toastify';

const FileCommentsModal = ({ element, onClose, show }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingComment, setIsLoadingComment] = useState(false);
    const [currentFile, setCurrentFile] = useState();

    const fetchData = useCallback(
        async (hideLoader) => {
            if (!hideLoader) {
                setIsLoading(true);
            }

            try {
                const { data } = await getFileInformation(element.file.id);

                setCurrentFile({
                    ...data,
                    _isFetching: false,
                    _isDraft: false,
                    comments: data.comments.sort(DriveHelper.Sort.byCreatedAt),
                });
            } catch (error) {
                console.error(error);
                toast.error(
                    'Something went wrong while fetching the comments. Please try again.',
                    {
                        className: 'custom-toast',
                    }
                );
            } finally {
                setIsLoading(false);
            }
        },
        [element]
    );

    useEffect(() => {
        if (show) {
            fetchData();
        } else {
            setIsLoading(false);
            setIsLoadingComment(false);
            setCurrentFile(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const onSendComment = useCallback(
        async (comment) => {
            setIsLoadingComment(true);

            try {
                await postFileComment(element.file.id, comment);
                await fetchData(true);
            } catch (e) {
                console.error(e);
                toast.error(
                    'Something went wrong while posting the comment. Please try again.',
                    {
                        className: 'custom-toast',
                    }
                );
            } finally {
                setIsLoadingComment(false);
            }
        },
        [element, fetchData]
    );

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>Comments</Modal.Header>
            <Modal.Body>
                {isLoading ? (
                    <div className="d-flex justify-content-center my-5 icon">
                        <Spinner />
                    </div>
                ) : (
                    <FileComment
                        fileElement={currentFile}
                        onSendComment={onSendComment}
                        fallback={() => (
                            <p className="text-center opacity-50 py-5">
                                Comments not available for this file.
                            </p>
                        )}
                        loading={isLoadingComment}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default memo(FileCommentsModal);
